module.exports = __webpack_public_path__ + "img/vertical_3_3_6000.83a71280.png";